import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function SpotHoldingsPnL() {
  return (
    <main className="container px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle>Holdings & PnL</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">Coming soon.</CardContent>
      </Card>
    </main>
  );
}
